import { usersApi } from "../api";
import { IUserForm } from "../types/user/userInterfaces";

const UserService = {
    /**
     * Obtiene todos los usuarios con paginación.
     * GET localhost:8080/api/v1/users/users-with-pagination?page=0
     */

    findAllUsersWithPagination: async (page: number, size: number) => {
        const customRoute = `/users-with-pagination?page=${page}&size=${size}`;
        try {
            const response = await usersApi.fetchCustom(customRoute);
            return response;

        } catch (error) {
            throw error;
        }
    },


    searchUsersWithPagination: async (query: string, page: number, size: number) => {
        const customRoute = `/search?query=${encodeURIComponent(query)}&page=${page}&size=${size}`;
        try {
            const response = await usersApi.fetchCustom(customRoute);
            return response;
        } catch (error) {
            throw error;
        }
    },


    searchLockedUsersWithPagination: async (query: string, page: number, size: number) => {
        const customRoute = `/search-locked?query=${encodeURIComponent(query)}&page=${page}&size=${size}`;
        try {
            const response = await usersApi.fetchCustom(customRoute);
            return response;
        } catch (error) {
            throw error;
        }
    },


    /**
     * Busca usuarios por nombre de usuario con paginación.
     * GET localhost:8080/api/v1/users/search-users-byname?username=Oscar&page=0
     */
    findByUsernameWithPagination: async (username: string, page: number, size: number) => {
        const customRoute = `/search-users-byname?username=${username}&page=${page}&size=${size}`;
        try {
            const response = await usersApi.fetchCustom(customRoute);
            return response;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Busca un usuario por nombre de usuario.
     * GET localhost:8080/api/v1/users/blocking/search-user-by-username?username=oscar&page=0
     */
    findByUsername: async (username: string, page: number, size: number) => {
        const customRoute = `/blocking/search-user-by-username?username=${username}&page=${page}&size=${size}`;
        try {
            const response = await usersApi.fetchCustom(customRoute);
            return response;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Obtiene la lista de usuarios bloqueados.
     * GET localhost:8080/api/v1/users/blocked?page=0
     */
    findBlockedUsers: async (page: number, size: number) => {
        const customRoute = `/blocked?page=${page}&size=${size}`;
        try {
            const response = await usersApi.fetchCustom(customRoute);
            return response;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Elimina un usuario por ID.
     * DELETE localhost:8080/api/v1/users/{id}
     */
    deleteUserById: async (id: number) => {
        try {
            const response = await usersApi.remove(id);
            return response;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Crea un nuevo usuario.
     * POST localhost:8080/api/v1/users
     */
    saveUser: async (user: IUserForm) => {
        try {
            const { confirmPassword, ...payload } = user;
            void confirmPassword;
            const response = await usersApi.add(payload);
            return response.data;
        } catch (error) {
            throw error;
        }
    },


    /**
     * Actualiza un usuario por ID.
     * PUT localhost:8080/api/v1/users/{id}
     */
    updateUser: async (id: number, user: IUserForm) => {
        try {
            const { confirmPassword, ...payload } = user;
            void confirmPassword;
            const response = await usersApi.modify(id, payload);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Obtiene un usuario por ID.
     * GET localhost:8080/api/v1/users/{id}
     */
    getUserById: async (id: number) => {
        try {
            const response = await usersApi.fetchById(id);
            return response.data;
        } catch (error) {
            throw error;
        }
    },


    /**
     * Actualiza la contraseña de un usuario.
     * POST localhost:8080/api/v1/users/update-password/{userId}
     */
    updatePassword: async (id: number, data: Record<string, unknown>) => {
        const customRoute = `/update-password/${id}`;
        try {
            const response = await usersApi.addCustom(customRoute, data);
            return response;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Bloquea o desbloquea un usuario por ID.
     * POST localhost:8080/api/v1/users/lock-User-Or-UnLock-User/{id}
     */
    lockUserOrUnLockUser: async (id: number) => {
        const customRoute = `/lock-User-Or-UnLock-User/${id}`;
        try {
            const response = await usersApi.addCustom(customRoute, {});
            return response;
        } catch (error) {
            throw error;
        }
    }
};

export default UserService;
